import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Dashboard-2(cropped).png"
import DocNavigation from "../../components/DocNavigation";

export default function RealTimeFinancialInsights() {
    return (
        <section className="space-y-16">

            {/* HERO */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Real-time Financial Insights
                </h1>

                <p className="text-md text-slate-600 max-w-4xl">
                    Financial decisions in event and banquet businesses cannot wait for
                    end-of-day summaries or manual calculations. EventFlow provides
                    real-time financial visibility across bookings, receipts, expenses,
                    procurement, and accounting.
                </p>

                <section className="border-l border-[#C9A24E] pl-4 mt-6">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        Every financial action in EventFlow immediately updates dashboards,
                        reports, and accounting records — giving management instant insight
                        into cash flow, revenue, and outstanding balances.
                    </p>
                </section>
            </section>

            {/* PROBLEM */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-4">Challenges Without Real-time Data</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>Delayed visibility of revenue and dues</li>
                    <li>Manual reconciliation at month-end</li>
                    <li>Incorrect cash position assumptions</li>
                    <li>Difficulty identifying unpaid bookings</li>
                </ul>
            </section>

            {/* SOLUTION */}
            <section className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4">
                <div>
                    <h3 className="font-semibold mb-3">
                        How EventFlow Delivers Real-time Insights
                    </h3>
                    <p className="text-slate-600 mb-3">
                        EventFlow continuously synchronizes financial data across all
                        operational modules.
                    </p>
                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Live revenue and due amount tracking</li>
                        <li>Instant updates on receipts & payments</li>
                        <li>Auto-updated supplier and customer balances</li>
                        <li>Integrated accounting impact</li>
                    </ul>
                </div>

                <div className="rounded-lg p-6">
                    <img src={img1} alt="" className="shadow-lg" />
                </div>
            </section>

            {/* BUSINESS VALUE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Business Impact</h3>
                <p className="text-slate-600 max-w-4xl">
                    With real-time financial insights, owners and managers make informed
                    decisions faster, reduce cash leakage, and maintain tighter control
                    over business finances without waiting for reports.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/no-double-booking" className="font-medium text-[#C9A24E]">
                        Multi-user Access Control
                    </Link>.
                </p>
            </section> */}

            <DocNavigation
                previous={{
                    title: "Prevent Double Bookings",
                    link: "/docs/no-double-booking"
                }}
                next={{
                    title: "Multi-user Access Control",
                    link: "/docs/access-control-bi"
                }}
            />

        </section>
    );
}
